import React from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_green.css";
import "./TimeSelector.css"; // Assuming you have a TimeSelector.css file with the provided styles

const TimeSelector = ({times:timeOptions, selectedTime, handleTimeSelection}) => {
  // const timeOptions = [
  //   ["09:00 AM", "10:00 AM", "11:00 AM"],
  //   ["01:00 PM", "02:00 PM", "03:00 PM"],
  //   ["04:00 PM", "05:00 PM", "06:00 PM"],
  //   ["07:00 PM", "08:00 PM", "09:00 PM"],
  //   ["10:00 PM", "11:00 PM", "12:00 AM"],
  // ];

  // const handleTimeSelection = (selectedTime) => {
  //   // Handle the selected time here
  //   console.log(selectedTime);
  // };

  return (
    <div className="time-selector col-12 col-md-6 mh-100 mt-md-4">
      {timeOptions.map((time) => selectedTime === time?(
        <>
            <div
              key={time}
              className="time-option TiHRjLF_QTwJrPFR65WG mb-2 mx-auto"
              onClick={() => handleTimeSelection(time)}
            >
              <p className = "time-text"> {time}h </p>
            </div>
        </>
      ):(
          <>
              <div
                key={time}
                className="time-option TiHRjLF_QTwJrPFR65WG mb-2 mx-auto"
                onClick={() => handleTimeSelection(time)}
              >
                <p className = "time-text"> {time} </p>
              </div>
          </>
      ))}
    </div>
  );
};

export default TimeSelector;
